import React from "react";

const OnlineOptionsBus = (props) => {
  const options = [
    {
      text: 'J’ai de la difficulté avec INTERAC en ligne. Pouvez-vous m’aider?',
      handler: props.actionProvider.OnlineBus1,
      id: 1
    },
    {
      text: 'Qu’est-ce que le service INTERAC en ligne et comment fonctionne-t-il?',
      handler: props.actionProvider.OnlineBus2,
      id: 2
    },
    {
      text: 'Qu’advient-il si un client n’utilise pas les services bancaires en ligne?',
      handler: props.actionProvider.OnlineBus3,
      id: 3
    },
    {
      text: 'Pourquoi le client doit-il quitter mon site Web? Qu’advient-il s’il ne revient pas?',
      handler: props.actionProvider.OnlineBus4,
      id: 4
    },
    {
      text: 'Comment dois-je traiter les remboursements?',
      handler: props.actionProvider.OnlineBus5,
      id: 5
    },
    {
      text: 'Qu’est-ce qu’une rétrofacturation et Interac en émet-elle?',
      handler: props.actionProvider.OnlineBus6,
      id: 6
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container debit-products'>{optionsMarkup}</div>;
};

export default OnlineOptionsBus;